// File contains generic consent models, which neither stand for NSC nor dealer consents.
// They are used for generic consent-components which can display both, NSC and dealer consents
import { RootTextBlock } from './nsc-consent-legal-text';

export interface ConsentCheckboxGroup {
  headline?: RootTextBlock;
  usageDefinitionId?: string;
  checkboxes: ConsentCheckbox[];
}

export interface ConsentCheckbox {
  key: string;
  label: string;
}

export enum ConsentType {
  DEALER = 'DEALER',
  NSC = 'NSC',
}

/** Maps usageId to flag if the consent is selected */
export type ConsentSelection = Readonly<Record<string, boolean>>;

export interface ConsentMetadata {
  majorVersion: number;
  minorVersion: number;
  date: Date;
}
